/**
* @license Apache-2.0
*
* Copyright (c) 2024 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

import format from '@stdlib/error-tools-fmtprodmsg';

// MODULES //

import Float64Array from '@stdlib/array-float64';

import Float32Array from '@stdlib/array-float32';
import Uint32Array from '@stdlib/array-uint32';
import Int32Array from '@stdlib/array-int32';
import Uint16Array from '@stdlib/array-uint16';
import Int16Array from '@stdlib/array-int16';
import Uint8Array from '@stdlib/array-uint8';
import Uint8ClampedArray from '@stdlib/array-uint8c';
import Int8Array from '@stdlib/array-int8';
import Complex64Array from '@stdlib/array-complex64';
import Complex128Array from '@stdlib/array-complex128';
import BooleanArray from '@stdlib/array-bool';

// FUNCTIONS //

/**
* Throws an error.
*
* @private
* @throws {Error} not implemented
*/
function notImplemented() {
	throw new Error( format('0iD00') );
}

// MAIN //

// Note: order should match `dtypes` order
var CTORS = [ // eslint-disable-line vars-on-top
	Float64Array,
	Float32Array,
	notImplemented, // FIXME: replace with `Float16Array` once implemented
	Int32Array,
	Uint32Array,
	Int16Array,
	Uint16Array,
	Int8Array,
	Uint8Array,
	Uint8ClampedArray,
	notImplemented, // FIXME: replace with `Complex32Array` once implemented
	Complex64Array,
	Complex128Array,
	BooleanArray
];

// EXPORTS //

export default CTORS;
